import React from 'react';
import SiteContainer from '~/components/SiteContainer';
import AdminUploadService from '~/containers/AdminUploadService';
import useCountriesService from '~/hooks/use-countries-service';
import Menu from '../Menu';

function CountriesServicePage() {
  const countriesService = useCountriesService();
  return (
    <SiteContainer>
      <Menu />
      <AdminUploadService
        {...countriesService}
        fileTitle='new countries list'
        nounPlural='countries'
      />
    </SiteContainer>
  );
}

export default CountriesServicePage;
